// extracted by mini-css-extract-plugin
export default {"previewCover":"SharePubliclyPreviewCover_previewCover__xiaTb","previewCoverFallback":"SharePubliclyPreviewCover_previewCoverFallback__kwK85"};